import { oz } from '@weft/utils';
import { BillingIntervalSchema, PaymentTermSchema } from '../../primitives';
import { ObjectIdSchema } from '../../primitives/object-id-schema';
import { withNullAsOptional } from '../../utils/literal-transforms';
import { NewLineItemProductCommitmentSchema } from '../line-item-product-commitment/new-line-item-product-commitment-schema';
import { NewLineItemProductVariantSchema } from '../line-item-product-variant/new-line-item-product-variant-schema';

export const NewLineItemProductSchema = oz.object({
  productId: withNullAsOptional(ObjectIdSchema),
  // externalProduct: // TODO: work on this
  // externalErp // TODO: work on this
  name: withNullAsOptional(oz.string()),
  basePrice: withNullAsOptional(oz.number()),
  proRata: oz.boolean(),
  rateMultiplier: withNullAsOptional(oz.number()),
  variants: oz.array(NewLineItemProductVariantSchema),
  commitment: NewLineItemProductCommitmentSchema.optional(),
  isPeriodicConsumption: withNullAsOptional(oz.boolean()),
  paymentTerm: PaymentTermSchema,
  billingInterval: BillingIntervalSchema,
  currencyCommitment: oz.number().optional(),
}).openapi('NewLineItemProduct');

export type NewLineItemProduct = oz.infer<typeof NewLineItemProductSchema>;